import { Component } from '@angular/core';

@Component({
    moduleId: module.id,
    templateUrl: 'page-not-found.component.html',
    styleUrls: ['page-not-found.component.scss'],
})
export class PageNotFoundComponent {}
